import apiClient from './client';

/** 저장된 대진표. 없으면 null (204) */
export async function fetchBracket(tournamentId) {
  const response = await apiClient.get(`/admin/competition-brackets/${tournamentId}`);
  return response.status === 204 || !response.data ? null : response.data;
}

/** 대진표 전체 저장. payload.version 이 서버와 다르면 409 */
export async function saveBracket(tournamentId, payload) {
  const { data } = await apiClient.put(`/admin/competition-brackets/${tournamentId}`, payload);
  return data;
}

/** 결과 확정 → 순위/전적이 회원 대회기록에 저장됨 */
export async function finalizeBracket(tournamentId) {
  const { data } = await apiClient.post(`/admin/competition-brackets/${tournamentId}/finalize`);
  return data;
}

/** 확정 해제 → 결과 삭제, 다시 수정 가능 */
export async function reopenBracket(tournamentId) {
  const { data } = await apiClient.post(`/admin/competition-brackets/${tournamentId}/reopen`);
  return data;
}

export async function fetchBracketResults(tournamentId) {
  const { data } = await apiClient.get(`/admin/competition-brackets/${tournamentId}/results`);
  return data;
}

/** 공개 대진표 (로그인 불필요): { bracket, participants, results }. 없으면 null (204) */
export async function fetchPublicBracket(tournamentId) {
  const response = await apiClient.get(`/competition-brackets/${tournamentId}`);
  return response.status === 204 || !response.data ? null : response.data;
}
